<template>
  <div class="dia-border grey" style="margin-top:20px">
    <div class="title-left u-flex u-row-between">

      <div class="u-flex">
        <div class="u-flex">
          <div class="head-title-lable">
            <!-- <span class="red">*</span> -->
            分段标题</div>
          <Input v-model="obj.value" placeholder="请输入" style="width: 280px"></Input>
        </div>

      </div>
      <div class="de-com" @click="remove">
        <img src="@/assets/images/del.png" width="18px" height="18px" />
      </div>
    </div>
    <div class="dia-line">

    </div>
    <Button type="primary" @click="open(1)">关联报警</Button>
    <div class="gl-btn">
      <Table :columns="columns1" :data="obj.data1" />
    </div>
    <Drawer class="common-drawer" width="1000" title="请勾选要关联的报警" :closable="false" v-model="drawerShow">
      <Row>

        <!-- <div class="u-flex" style="margin-right:6px" v-if="typeobj.type>1">
          <div class="head-title-lable">选择润滑点</div>
          <div>
            <Selec v-model="runvalue" style="width:200px">
              <Option v-for="item in comadminpotion" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
        </div> -->
        <Col span="8" v-if="typeobj.type>2" class="u-flex" style="margin-right:6px">
        <span style="width:60px">设备: </span>
        <Select @on-select="comconselctmth" 
        v-model="obj.ocmvalue" style="width:200px">
          <Option v-for="item in ocmoption" :value="item.id" :key="item.id">{{ item.value }}</Option>
        </Select>
        </Col>
        <Col span="8" v-if="typeobj.type>1" class="u-flex" style="margin-right:6px">
        <span style="width:60px">润滑点: </span>
        <Select @on-select="conselctmth" v-model="obj.runvalue" style="width:200px">
          <Option v-for="item in comadminpotion" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Col>
        <!-- <Col span="7" class="u-flex" style="margin-right:6px">
        <span style="width:80px">报警指标: </span>
        <Input style="width:200px" v-model='dataForm.deviceName' search placeholder="请输入" />
        </Col>


        <Col span="8" class="u-flex" style="margin-top:6px">
        <span style="width:90px">报警时间: </span>
        <Input style="width:200px" v-model='dataForm.deviceName' search placeholder="请输入" />
        </Col> -->
      </Row>
      <div class="lists clearfix">
        <!-- 列表 -->
        <div class="common-list" v-if="!spin">
          <!-- @on-select="listSelectChange"
           @on-selection-change="listSelectChange"
            -->
          <Table
          @on-select-all-cancel="allselcetcacle"
          @on-select-cancel="selcetcacle"
           @on-select-all="listSelectChange1" 
           @on-select="listSelectChange"
            ref="tabless" 
            class="equipmentTable" 
          :columns="dataColumn"
           :data="dataLists"></Table>
        </div>
        <div v-else style="height:696px;width:100%" class="u-flex u-row-center">
          <Spin></Spin>
        </div>
        <!-- 分页器 -->
        <div class="common-page fr" v-if='pageInfo.total'>
          <Page 
          show-total show-elevator
           :total="pageInfo.total" 
           :current="pageInfo.current" 
           :page-size="pageInfo.size"
            @on-change="relation"></Page>
        </div>
      </div>
      <div class="drawer-footer">
        <Button type="primary" @click="drawok()">提交</Button>
        <Button style="margin-left: 8px" @click="closeDrawer">取消</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
  import {
    getByDeviceId
  } from '@/api/operate/dataexprt'
  import {
    alarmPage
  } from '@/api/business/rhdetail.js'
  import moment from 'moment'
  import debounce from '@/util/debounce'
  import {
    ocmselect
  } from '@/api/business/rhlist'
  export default {
    name: "diatable",
    props: ['index', "item", "typeobj"],
    data() {
      return {
        comadminpotion: [],
        ocmoption: [],

        runvalue: "",
        obj: {
          value: "",
          data1: [],
          ocmvalue: "",
          runvalue: ""
        },
        columns1: [],

        drawerShow: false,
        dataForm: {
          deviceName: ""
        },
        dataColumn: [],
        oilSiteId: "",
        pageInfo: {
          oilSiteIds: [],
          size: 10,
          current: 1,
          total: 0,
        },
        dataLists: [],
        ztlist: [],
        charindex: false,
        spin: false
      }
    },
    watch: {
      obj: {
        deep: true,
        handler: function(value) {
          if (!this.charindex) return

          debounce(() => {
            this.$emit("setData", {
              type: "tables",
              index: this.index,
              title: value.value,
              table: value.data1,
              ocmvalue: value.ocmvalue,
              runvalue: value.runvalue
            })
          }, true)

        }
      }
    },
    mounted() {

      this.init()
    },
    methods: {
      //   changeSize(data) {
      //   this.pageInfo.size = data;
      //   this.relation();
      // },
      open() {
        this.$refs.tabless.selectAll(false);
        let zlist = this.obj.data1
        this.dataLists = this.dataLists.map((item) => {
          item._checked = false
        let find = zlist.find(e => e.identifierAlarmRecordId == item.identifierAlarmRecordId)
         if (find) {
            item._checked = true
          }
          return item
        })
        this.ztlist= this.$c.deepClone(zlist)
  

        this.drawerShow = true
      },
      remove() {
        this.$emit("remove", this.index)
      },
      closeDrawer() {
        this.ztlist = []
        this.drawerShow = false
      },
      drawok() {
   
       
        this.obj.data1 = this.$c.deepClone(this.ztlist)
        this.drawerShow = false
     
      },
      allselcetcacle(e){
       
        let dataLists= this.$c.deepClone(this.dataLists)
        let ztlist1= this.$c.deepClone(this.ztlist)
        let arr=[]
        ztlist1.forEach(element=>{
          let find = dataLists.findIndex(e => e.identifierAlarmRecordId == element.identifierAlarmRecordId)
          if(find==-1){
            arr.push(element)
          }
        })
         this.ztlist=arr

        //  this.obj.data1.forEach((dataitem,key)=>{
        //   let find = dataLists.findIndex(e => e.identifierAlarmRecordId == dataitem.identifierAlarmRecordId)
      
        //  if(find>-1){
        //     this.ztlist.splice(find,1)
        //   }
        // })
  
       

      },
      listSelectChange1(e, row) {
    
        if (e.length==0) {
       
          return
        }
        
        e.forEach((item, index) => {
          let find = this.ztlist.find(e => e.identifierAlarmRecordId == item.identifierAlarmRecordId)
         
         if (!find) {
            this.ztlist.push(item)
          }
        })
     
      },
      selcetcacle(arr,row){
        
         let find = this.ztlist.findIndex(e => e.identifierAlarmRecordId == row.identifierAlarmRecordId)
          if(find>-1){
            this.ztlist.splice(find,1)
          }
      },
      listSelectChange(arr, row) {
   
        // let item= row
   

        let find = this.ztlist.findIndex(e => e.identifierAlarmRecordId == row.identifierAlarmRecordId)

        if (find == -1) {
          this.ztlist.push(row)
        }

      },
      timeChange(times) {
        times = times / 1000
        let d = moment.duration(+times, "seconds");
        return Math.floor(d.asDays()) +
          "天" +
          d.hours() +
          "时" +
          d.minutes() +
          "分" +
          d.seconds() +
          "秒"


      },
      async relation(index = 1,name="page") {
      
        this.dataLists = []

        this.pageInfo.current = index
        this.pageInfo.oilSiteIds = [this.oilSiteId]
        // this.drawerShow = true
        this.spin = true
        let data = await alarmPage(this.pageInfo)
        if (data.code === "00000") {
          const datas = data.data;
          this.spin = false
          this.dataLists = datas.records.map((item) => {
            item._checked = false
            let pditem = this.ztlist.findIndex(data1item => data1item.identifierAlarmRecordId == item.identifierAlarmRecordId)
    
           if (pditem>-1) {
              item._checked = true
            }
            return item
          })
          this.pageInfo.total = datas.total;
        }
      },
      async getcustlist() {
    
        const {
          customerId, //
        } = this.typeobj

        const {
          ocmvalue
        } = this.item

        let {
          data
        } = await ocmselect({ //获取设备
          gangedValueMap: {
            tenantId: customerId
          },
          size: 200,
          type: "device",
          value: "",
        })
        if (data.records.length == 0) return
        let _ocmvalue = undefined
        this.ocmoption = data.records

        if (ocmvalue) {
          _ocmvalue = ocmvalue
        } else {
          _ocmvalue = this.ocmoption[0].id //这是第一次进入的情况
        }

        this.obj.ocmvalue = _ocmvalue

        this.comconselctmth({
          value: _ocmvalue
        }, "init")
      },

      async comconselctmth(e, index = "cit") {

        let runvalue = this.item.runvalue
        const {
          value
        } = e
        this.dataLists = []
        // this.obj.data1 = []

        let data = await getByDeviceId({
          deviceId: value
        })

       if(data.length==0){
        this.comadminpotion=[]
       }else{
          this.comadminpotion = data.map(({
          id,
          name
        }) => {
          return {
            value: id,
            label: name
          }
        })
       }
        

        if (index == "init") {

          if (runvalue) {
            this.obj.runvalue = runvalue
          } else {

            this.obj.runvalue = this.comadminpotion[0].value
          }
          this.oilSiteId = this.obj.runvalue

          this.$nextTick(() => {
            this.ztlist = this.$c.deepClone(this.obj.data1)
            this.relation(1,'init')

          })
        }else{
          this.ztlist=[]
        }


      },
      getequipment() { //如果是设备
        const {
          deviceId
        } = this.typeobj
        this.comconselctmth({
          value: deviceId
        }, "init")

      },
      conselctmth(e) {
        this.dataLists = []
        // this.obj.data1 = []
        
       
        const {
          value
        } = e
        this.$nextTick(() => {
          this.oilSiteId = this.obj.runvalue
          this.ztlist = []
          this.relation(1,'init')
        })

        // const {runvalue}=this.typeobj

      },
      async init() {
        this.charindex = false


        this.dataColumn = [{
            type: 'selection',
            width: 70,
            align: 'left',
            _checked: true
          },
          {
            title: "报警指标",
            key: "identifierName",
            align: "left",
            width: 200,
            render: (h, params) => {
              const item = params.row;
              //   return h("div", item.describeRule || "-");
              return h("Tooltip", {
                  props: {
                     
                    maxWidth: 200,
                    placement: 'top',
                    name: 'true',
                    content: item.identifierName,
                    theme: "light",
                    transfer: true
                  },
                },
                [
                  h('div', {
                    style: {
                      "width": "190px",
                      "overflow": "hidden",
                      "word-break": "break-all",
                      "text-overflow": "ellipsis",
                      "-webkit-line-clamp": 2,
                      "text-overflow": "-o-ellipsis-lastline",
                      'line-clamp': 2,
                      "-webkit-box-orient": "vertical",
                      "display": "-webkit-box !important",
                    }
                  }, item.identifierName || "-")
                ]
              )
            },
          },
          // {
          //   title: "报警指标",
          //   align: 'left',
          //   key: "identifierName",
          //   align: 'left',
          //   width: "200",
          //   render: (h, params) => {
          //     const item = params.row;
          //     return h("div", item.identifierName || "-");
          //   },
          // },
          // {
          //   title: "润滑点"类型,
          //   key: "oilSiteTypeName",
          //   align: 'left',
          //   width: "180",
          //   render: (h, params) => {
          //     const item = params.row;
          //     return h("div", item.oilSiteTypeName || "-");
          //   },
          // },

          // {
          //   title: "报警描述",
          //   key: "describe",
          //   width: "300",
          //   render: (h, params) => {
          //     const desc = params.row.describe;
          //     let desc250 = "";
          //     if (desc && desc.length > 250)
          //       desc250 = desc.substring(0, 250) + "...";
          //     else desc250 = desc || "-";
          //     return h("div", desc250);
          //   },
          // },
          {
            title: "报警开始时间",
            key: "alarmStartTime",
            align: 'left',
            width: "180",
            render: (h, params) => {
              const item = params.row;
              return h("div", item.alarmStartTime || "-");
            },
          },
          {
            title: "报警结束时间",
            key: "alarmEndTime",
            align: 'left',
            width: "180",
            render: (h, params) => {
              const item = params.row;
              return h("div", item.alarmEndTime || "-");
            },
          },
          {
            title: "报警持续时间",
            key: "alarmDuration",
            align: 'left',
          
            render: (h, params) => {
              const item = params.row;
              return h(
                "div",
                this.timeChange(item.alarmDuration)
                // (item.alarmDuration &&
                //     (item.alarmDuration / 60 / 60 / 1000).toFixed(
                //         2
                //     ) + " 小时") ||
                //     "-"
              );
            },
          },

        ]
        this.columns1 = [{
            title: '序号',
            type: 'index',
            align: 'left',
            width: 70,
          },
          {
            title: '设备名称',
            key: 'deviceName',
            align: 'left',
            width: 180,
            render: (h, params) => {
              const item = params.row;
              return h("div", item.deviceName || "-");
            },
          },
          {
            title: '润滑点名称',
            key: 'oilSiteName',
            width: 150,
            align: 'left',
            // sortable: true,
            // ellipsis: true,

            render: (h, params) => {

              return h('div', params.row.oilSiteName || "-")
            }
          },
          {
            title: "报警指标",
            align: 'left',
            key: "identifierName",
            align: 'left',
            width: "300",
            render: (h, params) => {
              const item = params.row;
              return h("div", item.identifierName || "-");
            },
          },
          {
            title: "报警描述",
            key: "describe",
            align: 'left',
            width: "300",
            render: (h, params) => {
              const desc = params.row.describe;
              let desc250 = "";
              if (desc && desc.length > 250)
                desc250 = desc.substring(0, 250) + "...";
              else desc250 = desc || "-";
              return h("div", desc250);
            },
          },
          {
            title: "报警开始时间",
            key: "alarmStartTime",
            width: "180",
            align: 'left',
            render: (h, params) => {
              const item = params.row;
              return h("div", item.alarmStartTime || "-");
            },
          },
          {
            title: "报警结束时间",
            key: "alarmEndTime",
            width: "180",
            align: 'left',
            render: (h, params) => {
              const item = params.row;
              return h("div", item.alarmEndTime || "-");
            },
          },
          {
            title: "报警持续时间",
            key: "alarmDuration",
            // width: "150",
            align: 'left',
            render: (h, params) => {
              const item = params.row;
              return h(
                "div",
                this.timeChange(item.alarmDuration)
                // (item.alarmDuration &&
                //     (item.alarmDuration / 60 / 60 / 1000).toFixed(
                //         2
                //     ) + " 小时") ||
                //     "-"
              );
            },
          },
          {
            title: "操作",
            key: "address",
            align: 'left',
            fixed: "right",
            width: 100,
            className: "action",
            render: (h, params) => {
              const index = params.indedx;
              return h("div", [
                h(
                  "span", {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.obj.data1.splice(index, 1)

                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ]
        const {
          type
        } = this.typeobj
   
        let item = this.$c.deepClone(this.item)
     
        const {
          ocmvalue,
          runvalue,
          title
        } = item
        this.obj.value = title
        this.obj.ocmvalue = ocmvalue
        this.obj.runvalue = runvalue
        if (type == 1) {
          this.oilSiteId = await this.typeobj.oilSiteId
           this.ztlist = this.$c.deepClone(this.obj.data1)
          this.relation(1,'init')
        } else if (type == 3) { //如果是客户的话
          await this.getcustlist()
        } else { //如果是设备
          await this.getequipment()
        }
        this.obj.data1 = this.$c.deepClone(this.item.table)
        setTimeout(() => {
          this.charindex = true
        }, 1000)


        // if(this.typeobj.oilSiteId){
        //    this.oilSiteId=this.typeobj.oilSiteId
        // }



      }
    }
  }
</script>
<style>
  .gl-btn {
    margin-top: 20px;
    margin-bottom: 8px;
  }



  .red {
    color: red;
  }
</style>